import React from "react";
import Button from "./Button";
import "./PerformRequestBox.css";

function PerformRequestBox({ btnDisabled, onTacClick, onVerifyClick }) {
  return (
    <div className="performRequest">
      <div className="tacText">
        <span className="redBold">Make sure to disable your WiFi connection.</span>
        <br />
        <br /> I have read and agree with the{" "}
        <span className="underline" onClick={onTacClick}>
          terms and conditions
        </span>
      </div>
      <Button disabled={btnDisabled} onClick={onVerifyClick} text="Verify" />
    </div>
  );
}

export default React.memo(PerformRequestBox);
